<template>
<div class="bg-white rounded border p-3" v-if="auth.token && auth.login">
  <div class="col-12 col-md-12 " style="width: 100%;">
            <div class="card-header">
              <ul class="nav nav-tabs card-header-tabs" role="tablist" style="flex-wrap:nowrap !important">
                <li class="nav-item w-50" >
                  <a class="nav-link w-100 " @click="flagFlag('one')" style="width: max-content;" role="tab" aria-controls="first" aria-selected="true">سفارشات</a>
                </li>
                <li class="nav-item w-50" >
                  <a class="nav-link w-100" @click="flagFlag('two')" style="width: max-content;" role="tab" aria-controls="two" aria-selected="true">شارژ و اینترنت</a>
                </li>
              </ul>
            </div>
            <div class="card-body">
              <div class="tab-content">
                <div class="tab-pane fade  overflow-auto" :class="{'active show' : flag.one}" id="first" role="tabpanel" aria-labelledby="first-tab">
                  <!-- <div class="alert alert-warning my-1 border-0 prfont-weight text-center w-100" role="alert">شما تا این لحظه {{ convertToPersian(String(sumItems)) }} تومان در {{ convertToPersian(String(countItems)) }} فاکتور در فروش راداَپ سهیم بوده اید.</div> -->
                  <table class="mt-2 table table-hover table-bordered table-striped" id="orderTable">
                    <thead>
                      <tr>
                        <th scope="col">شماره سفارش</th>
                        <th scope="col">نوع سفارش</th>
                        <th scope="col">تاریخ</th>
                        <th scope="col">مبلغ (تومان)</th>
                        <th scope="col">آدرس</th>
                        <th scope="col">فاکتور</th>
                        <th scope="col">عملیات</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in items" :key="item.id" :data-id="item.id" >
                        <td >{{convertToPersian(String(item.id))}}</td>
                        <td>{{item.type}}</td>
                        <td>{{item.time}}</td>
                        <td>{{convertToPersian(String(item.price))}}</td>
                        <td style="color:#FF515B;">{{item.address}}</td>
                        <td class="prcolor-blue retrieval pr-pointer linked" >
                          <router-link :to="{name:'Factor',params:{id:item.pre_id}}">
                              نمایش
                          </router-link>
                          <!-- <a :href="'https://radap.ir/Backend/config/tcpdf/examples/factor.php?id='+item.id" target="_blank">نمایش</a> -->
                        </td>
                        <td class="prcolor-blue retrieval pr-pointer linked text-info" @click="reOrder(item.pre_id)">
                          سفارش مجدد
                        </td>
                      </tr>
                    </tbody>
                  </table>
              </div>
                <div class="tab-pane fade overflow-auto" :class="{'active show' : flag.two}" id="two" role="tabpanel" aria-labelledby="two-tab">
                  <div class="alert alert-warning my-1 border-0 prfont-weight text-center w-100" role="alert" v-if="showCard == 'month'">شما در این ماه {{ convertToPersian(String(countCard)) }} بار و مجموع {{ convertToPersian(String(sumCard)) }} تومان از راداَپ شارژ و اینترنت خریده اید.</div>
                  <div class="alert alert-warning my-1 border-0 prfont-weight text-center w-100" role="alert" v-else>شما تا این لحظه {{ convertToPersian(String(countCard)) }} بار و مجموع {{ convertToPersian(String(sumCard)) }} تومان از راداَپ شارژ و اینترنت خریده اید.</div>
                  <table class="mt-2 table table-hover table-bordered table-striped">
                    <thead>
                      <tr>
                        <th scope="col">شماره سفارش</th>
                        <th scope="col">تراکنش</th>
                        <th scope="col">اپراتور</th>
                        <th scope="col">موبایل</th>
                        <th scope="col">تاریخ</th>
                        <th scope="col">مبلغ (تومان)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in cardItems" :key="item.id" :data-id="item.id" >
                        <td >{{convertToPersian(String(item.id))}}</td>
                        <td>{{item.type}} <span v-if="item.name">({{item.name}})</span></td>
                        <td>{{item.operator == 'MTN' ? 'ایرانسل' : 'MCI' ? 'همراه اول' : 'رایتل'}}</td>
                        <td>{{convertToPersian(String(item.mobile))}}</td>
                        <td>{{item.time}}</td>
                        <td>{{convertToPersian(String(item.amount))}}</td>
                      </tr>
                      <tr v-if="showCard == 'month'">
                        <td colspan="6" class="text-center" @click="showCard = 'all',getCarding()"><i class="fa fa-chevron-down" ></i> نمایش همه</td>
                      </tr>
                    </tbody>
                  </table>
              </div>
            </div>
          </div>
  </div>
</div>

<div class="text-danger" v-else>
شمامجوز دسترسی به این صفحه را ندارید
</div>
</template>

<script setup>
import { alertBox } from "@/composables/silverBox";
import { ref,reactive } from "@vue/reactivity";
import { convertToPersian } from "@/composables/digits";
import { useAuth } from '@/store/auth'
let auth = useAuth()
let items = ref();
let countItems = ref();
let sumItems = ref();
let countCard = ref();
let sumCard = ref();
let cardItems = ref();
let showCard = ref('month');
let flag = reactive({
  one : true,
  two : false
}) 
auth.getToken()
getOrders();
getCarding();
async function getOrders(){
  const formdata = new FormData();
  formdata.append("token", auth.token);
  let response = await fetch('https://radap.ir/Backend/api/account/order/get.php',{
                    method: 'POST',
                    body: formdata
                  })
  let data = await response.json()
    items.value = data.data;
    countItems.value = data.count;
    sumItems.value = data.sum;
}
async function getCarding(){
  const formdata = new FormData();
  formdata.append("token", auth.token);
  formdata.append("show", showCard.value);
  let response = await fetch('https://radap.ir/Backend/api/account/order/cards.php',{
                    method: 'POST',
                    body: formdata
                  })
  let data = await response.json()
    cardItems.value = data.data;
    countCard.value = data.count;
    sumCard.value = data.sum;
}
function reOrder(){
   alertBox("این قابلیت در حال حاضر فعال نیست")
}

function flagFlag(num){
  flag.one = false
  flag.two = false
  if(num == 'one'){
    flag.one = true
  }else{
    flag.two = true
  }
}
</script>

<style scoped>
/* @import "../../../../assets/css/account.css";
table thead tr th{
  text-align: right;
} */
</style>